import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IdleService } from 'src/app/core/services/idle.service';
import { Router } from '@angular/router';
import { RouteService } from 'src/app/core/services/route.service';

@Component({
  selector: 'app-refresh-token-modal',
  templateUrl: './refresh-token-modal.component.html',
  styleUrls: ['./refresh-token-modal.component.scss'],
})
export class RefreshTokenModalComponent implements OnInit {
  timer: any;
  counterTime: any;
  totalTimeOut = 60 * 2;
  idleWebWorker!: Worker;
  @Output() refreshToken = new EventEmitter();
  @Output() logout = new EventEmitter();
  constructor(
    private ngbModal: NgbActiveModal,
    public idelService: IdleService,
    private router: Router,
    private route: RouteService
  ) {}

  ngOnInit(): void {
    let display = document.querySelector('#clockdiv');
    this.startTimer(this.totalTimeOut, display);
  }

  onActionTrigger(actionType: string): void {
    this.idleWebWorker?.terminate();
    if (actionType === 'resume') {
      try {
        localStorage.removeItem('timeout');
        // this.authService
        //   .refreshToken()
        this.refreshToken.emit('true');
        // .then(() => {
        this.idelService.reset();
        clearInterval(this.counterTime);
        this.ngbModal.close();
      } catch (e: any) {
        this.router.navigate(['auth', 'login']);
      }
    }
    if (actionType === 'logout') {
      clearInterval(this.counterTime);
      this.ngbModal.close();
      // this.authService.logout();
      this.logout.emit('true');
    }
  }

  startTimer(duration: number, display: Element | null) {
    this.idleWebWorker?.terminate();
    if (typeof Worker !== 'undefined') {
      this.idleWebWorker = new Worker(
        new URL('./../../../core/web-workers/idle-worker.worker', import.meta.url),
        {
          type: 'module',
        }
      );

      this.idleWebWorker.onmessage = ({ data }) => {
        const item = localStorage.getItem('timeout') as unknown as number;
        if (item === null) {
          this.idleWebWorker?.terminate();
          this.ngbModal.close();
          this.idelService.reset();
          this.route.getApplicationName();
        }
        display!.textContent = data?.minutes + ':' + data?.seconds;
        if (data?.timer == 0) {
          this.onActionTrigger('logout');
          this.idleWebWorker?.terminate();
        }
      };
      this.idleWebWorker.onerror = (err) => {
        console.log('error', err);
      };

      this.idleWebWorker.postMessage({
        type: 'sessionEndTimer',
        time: duration,
      });
    }
  }
}
